// extracted by mini-css-extract-plugin
export default {"class":"ChildrenPage_class__Ydzjs"};